export default "__VITE_ASSET__ZJS0afOm__"